import React from "react"


function About() {
    return(
        <div className="section">
        <h2>About</h2>

         <p>Hello! I am a developer dedicated to creating dynamic, user-friendly, and impactful digital experiences. With a strong foundation in both front-end and back-end development, I thrive on turning complex ideas into elegant, functional, and visually compelling websites.</p>

<p>With a background in graphic design and software development, I specialize in blending creativity with technical expertise. I have a certification as a Full-Stack Software Developer from USF and have worked for 2+ years as a Web Designer and Developer. I’ve worked on projects ranging from sleek, responsive designs to robust, data-driven applications, ensuring each solution is tailored to meet user needs and client goals.</p>

<p>In my free time, I particularly enjoy reading, hanging out with my fiancée and our two dogs, or spending time doing some creative writing!</p>

<h4>My Expertise</h4>
<ul>
  <li>Web Design: Crafting intuitive and visually engaging designs that prioritize user experience.</li>
  <li>Front-End Development: Utilizing modern technologies like React, Angular, and Vue.js to build interactive and responsive interfaces.</li>
  <li>Back-End Development: Developing scalable and secure server-side solutions using Node.js, Express, PHP, and SQL databases.</li>
  <li>Full-Stack Solutions: Bridging the gap between design and development for seamless project execution.</li>
  <li>WordPress Development: Creating custom themes and plugins to extend the functionality of WordPress websites.</li>
</ul>
</div>
    )
}

export default About;
